module.exports = __webpack_public_path__ + "assets/img/btn-back-f0d9099c.png";